__webpack_require__.p = "/seratscanner/";